import React from 'react';
import PropTypes from 'prop-types';

import ProductPromoCard from './product/ProductPromoCard.jsx';
import ProductCard from './product/ProductCard.jsx';
import RecipeCard from './recipe/RecipeCard.jsx';
import RecipePromoCard from './recipe/RecipePromoCard.jsx';
import ContentCard from './content/CardTypeContentCard.jsx';
import RelatedCard from './related/RelatedCard.jsx';
import ArticleCard from './article/ArticleCard.jsx';
import PageCard from './page/PageCard.jsx';
import FeaturedCard from './featured/FeaturedCard.jsx';

const RenderCardType = ({ type, promo = false, props }) => {
  const types = {
    product: !promo ? <ProductCard {...props} /> : <ProductPromoCard {...props} />,
    recipe: !promo ? <RecipeCard {...props} /> : <RecipePromoCard {...props} />,
    content: <ContentCard {...props} />,
    page: <PageCard {...props} />,
    related: <RelatedCard {...props} />,
    article: <ArticleCard {...props} />,
    featured: <FeaturedCard {...props} />,
  };

  if (type in types) return types[type];

  return types.content; // Default to content type if type is not recognized
};

RenderCardType.propTypes = {
  type: PropTypes.oneOf(['product', 'page', 'recipe', 'content', 'related', 'article', 'featured']), // Corrected to PropTypes.oneOf
  promo: PropTypes.bool,
  props: PropTypes.object, // Ensure props are validated as an object
};

RenderCardType.defaultProps = {
  promo: false,
  props: {},
};

export default RenderCardType;